export const LOCALE = {
	en: 'english',
	ja: 'japanese',
	vi: 'vietnamese'
}
